<template>
  <div>
    <template v-if="!loaded">
      <course-skeleton v-for="n in skeletonCount" :key="n" :skeletonCount="skeletonCount"></course-skeleton>
    </template>

    <div class="products-wrapper" :class="skeletonCount ? 'grid-' + skeletonCount : ''" v-else>
      <template v-for="course in courses">
        <course-card :course="course"></course-card>
      </template>
    </div>

    <template v-if="loaded && currently_paginating">
      <course-skeleton v-for="n in 4" :key="n" :skeletonCount="skeletonCount"></course-skeleton>
    </template>
  </div>
</template>

<script>
    import Global from '../../mixins/Global'
    import Course from '../../mixins/v2/Course';
    import CourseSkeleton from './CourseSkeleton.vue'
    import CourseCard from "./CourseCard";

export default {
  name: 'CoursesCards',

        mixins: [Global, Course],

        components: {
            'course-card': CourseCard,
            'course-skeleton' : CourseSkeleton
        },

  data() {
    return {
      envoyer_release_id,
      light_colors: ['light_gray', 'light_green'],
    }
  },

  props: {
    courses: {
      required: true
    },

    loaded: {
      required: true
    },

    skeletonCount: {
      default: 8,
    },

    currently_paginating: {
      default: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.products-wrapper {
  padding-top: 24px;
  padding-bottom: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  grid-auto-rows: 1fr;

  @media(max-width: 1170px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media(max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media(max-width: 620px) {
    grid-template-columns: 1fr;
  }

  &.grid-3 {
    grid-template-columns: 1fr 1fr 1fr;

    @media(max-width: 1170px) {
      grid-template-columns: 1fr 1fr;
    }

    @media(max-width: 620px) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
